let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hgHpq")).then(() => parcelRequire('1dTYz'));